import { defineStore } from "pinia";
import type { Company, Brand } from "@Shared";

export const useCompanyStore = defineStore("company", {
    state: () => ({
        company: null as Company | null,
        brand: null as Brand | null
    }),
    
    actions: {
        setCompany(newCompany: Company) {
            this.company = newCompany;
        },
        setBrand(newBrand: Brand | null) {
            this.brand = newBrand;
        },
    }
});
